/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SequentiallyBetLineInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetLineInitialWPController";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiMultiplierEvents} from "../../multiplierIndicator/TombOfNefertitiMultiplier";
import {TombOfNefertitiReelStopPresentationController} from "../../reelStopPresentation/TombOfNefertitiReelStopPresentationController";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {TombOfNefertitiAnimatedWinlineController} from "../animatedwinlines/TombOfNefertitiAnimatedWinlineController";
import {CoinsFountain} from "../bigwin/CoinsFountain";
import {TombOfNefertitiInitCurseRespinController} from "../curse/TombOfNefertitiInitCurseRespinController";
import {TombOfNefertitiInitialWinCountUp} from "./TombOfNefertitiInitialWinCountUp";
import {TombOfNefertitiInitialWPView} from "./TombOfNefertitiInitialWPView";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class TombOfNefertitiInitialWPController extends SequentiallyBetLineInitialWPController {

    private _gameView:TombOfNefertitiInitialWPView;
    private _winCountUp:TombOfNefertitiInitialWinCountUp;

    private _coinsFountain:CoinsFountain;

    private _layer:PIXI.Container;
    private _animItems:PIXI.Sprite[] = [];
    private _nextGameMode:string = "";
    private _currentGameMode:string = "";

    private _isMultiplierShown:boolean = false;
    private _canShowReSpinWinAmount:boolean = false;
    private _isReSpinAmountItemShown:boolean = false;
    private _reSpinWinAmount:number = 0;

    private _abortTl:Timeline | null;

    private _isShowingYellow:boolean = false;
    private _isFinishPending:boolean = false;

    private _winType:string | null;
    private _countUpSound:string = "";
    private _isFinishedCalled:boolean = false;

    private _finishMethodTween:TweenLite | null = null;

    constructor(indexes:[number, number]) {
        super(indexes);

        let item:PIXI.Sprite,
            symPos:number[];

        this._gameView = new TombOfNefertitiInitialWPView();
        this._winCountUp = new TombOfNefertitiInitialWinCountUp("INITIAL_WIN", true);
        this._winCountUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.55);
        StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);

        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.SYMBOLS_ANIMATION.name);
        for(let i:number = 0; i < TombOfNefertitiGameConfig.instance.REELS_NUM; ++i) {
            symPos = Helper.getSymbolPositions(i, 0);

            item = new PIXI.Sprite();

            item.position.set(symPos[0], symPos[1]);
            item.anchor.set(0.5);
            item.visible = false;

            this._animItems[i] = item;

            this._layer.addChild(item);
        }

        this._coinsFountain = new CoinsFountain();
    }

    protected parseFeatureGameData(data:TombOfNefertitiParsedGameData):void {
        this._nextGameMode = data.nextMode;
        this._currentGameMode = data.mode;

        this._isMultiplierShown = false;
        this._isReSpinAmountItemShown = false;

        this._canShowReSpinWinAmount = (data.totalRespinWin > 0 && (data.nextMode === GameMode.NORMAL || data.nextMode === GameMode.FREESPIN));
        if(this._canShowReSpinWinAmount) {
            this._reSpinWinAmount = data.totalRespinWin;
        }

        this._gameView.stickySymbols = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []) : []; // need to type cast it as this reduce will not work directly on boolean.

        this._winType = TombOfNefertitiSoundConfig.getNormalWinSoundName(data.currentWinRatioConfig!);
        this._winCountUp.winType = data.currentWinRatioConfig!.text;

        // #403
        TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalRespinWin <= data.playedBetValue));
    }

    protected getNextSymbolAnimationTimeOffset():number {
        return 0.2;
    }

    protected getNextBetWinAnimationTimeOffset():number {
        return 0.2;
    }

    protected addWinCountUpToTimeline(timeline:Timeline):void {
        // #417
        timeline.add(this.showBetlineAmountInitialWin(this._gameData!.betWins), 0);

        if(this._gameData!.isBigWin) {
            return;
        }

        const totalWin:number = this._gameData!.totalWin,
            duration:number = this._gameData!.currentWinRatioConfig!.duration;

        const startTime:number = this.setCountUpSound();
        const countUpTimeline:TimelineLite = new TimelineLite();

        // #403
        if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
            countUpTimeline.add(() => SlotGame.sound.playEffect(this._countUpSound));
        }
        countUpTimeline.add(this._winCountUp.getCountUpAnimation(0, this._gameData!.singleWin, duration, this._gameData!.currentMultiplier, true, this._coinsFountain));
        countUpTimeline.add(() => SlotGame.winFieldController.showWinField(totalWin));
        countUpTimeline.add(this._winCountUp.getEndingAnimation(this._gameData!.singleWin, true));

        if(this._canShowReSpinWinAmount) {
            countUpTimeline.add(() => {
                this._winCountUp.showTotalWin(this._reSpinWinAmount);
                this._gameView.showTotalReSpinText();
                this._isReSpinAmountItemShown = true;
            });
            //adding blank animation for pause purpose in the presentation so that total respin win amount is shown.
            let currentModeFreeSpin:boolean = (this._currentGameMode.indexOf(GameMode.FREESPIN) !== -1),
                isAutoplayActive = GameSetting.isAutoplayRound;

            if(currentModeFreeSpin || (!currentModeFreeSpin && (isAutoplayActive || (this._nextGameMode === GameMode.FREESPIN)))) {
                countUpTimeline.add(TweenLite.to(() => {
                }, 1.5, {}));
                countUpTimeline.add(() => EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN")), countUpTimeline.totalDuration() + 0.6);
            }
        }

        if(this._gameData!.mode.indexOf("FREESPIN") !== -1 && this._gameData!.nextMode !== GameMode.NORMAL) {
            countUpTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE)), countUpTimeline.totalDuration() + 0.6);
            countUpTimeline.add(TweenLite.to(() => {}, 2, {}));
        }

        timeline.add(countUpTimeline, startTime + 0.1);

        // #403
        if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
            timeline.add(() => {
                SlotGame.sound.stopEffect("win-tiny", 200);
            }, startTime);
        }
    }

    protected hasWin():boolean {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiReelStopPresentationController.CLEAR_ATTENTION_FROM_REEL, -1));
        if(this._currentGameMode.indexOf('RESPIN') !== -1) {
            if(this._gameData!.betWins.length === 0) {
                this._gameView.showTotalReSpinText();
                this._winCountUp.showTotalWin(this._reSpinWinAmount);
            }
        }

        if(this._nextGameMode.indexOf('RESPIN') === -1) {
            if(!((this._currentGameMode.indexOf(GameMode.FREESPIN) === -1) && (this._nextGameMode.indexOf(GameMode.FREESPIN) !== -1))) {
                EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiReelStopPresentationController.CLEAR_LANDING_ANIMATION_FROM_REEL));
            }
        }

        if(this._gameData!.betWins.length === 0) {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE, true));
        }

        return true;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);

        if(isAborted) {
            this._isFinishedCalled = true;
            this._isFinishPending = false;
            if(!this._gameData!.isBigWin) {
                SlotGame.winFieldController.showWinField();
            }
        }
        TweenLite.killTweensOf(this._finishMethodTween!);
        this._finishMethodTween = null;

        // #417
        StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChildren();

        this._coinsFountain.stopFountain();

        this._abortTl = null;

        let item:PIXI.Sprite;

        for(let i:number = 0; i < this._animItems.length; ++i) {
            item = this._animItems[i];

            TweenLite.killTweensOf(item);
            item.visible = false;
        }

        if(this._countUpSound !== "") {
            SlotGame.sound.stopEffect(this._countUpSound);
        }
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiAnimatedWinlineController.CLEAN_UP_ANIMATED_WINLINE));

        if(this._isReSpinAmountItemShown && isAborted) {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE, isAborted));
            return;
        }
        if(this._isMultiplierShown && isAborted) {
            return;
        }

        if(isAborted) {
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE, isAborted));
            this._abortTl = (this._winCountUp.abort(this._gameData!.singleWin, isAborted, this._gameData!.currentMultiplier, this._gameData!.isBigWin))!;

            if(this._canShowReSpinWinAmount && this._abortTl) {
                this._gameView.showTotalReSpinText();
                const duration:number = this._abortTl.totalDuration();

                TombOfNefertitiGameConfig.instance.START_DELAY_FOR_RESPIN_WIN_SHOW = duration + 1.3;
                //EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiSpinEvent.ADD_DELAY_IN_START_SPIN, duration + 1.3));

                TweenLite.to(() => {}, duration, {
                    onComplete : () => {
                        //this._gameView.showTotalReSpin(this._reSpinWinAmount);
                        this._isReSpinAmountItemShown = true;

                        TombOfNefertitiGameConfig.instance.START_DELAY_FOR_RESPIN_WIN_SHOW = 0;
                    }
                });
            }

            SlotGame.sound.fadeAmbience(1, 500);
        }
    }

    protected addSingleBetWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:TimelineLite, startTime:number):number {
        const symbolsNum:number = betLineWinData.nrOfSymbols;
        let symbol:StateReelSymbol | null;
        let symbolDelay:number = 0;

        for(let i:number = 0; i < symbolsNum; i++) {
            symbol = this.findSymbol(i * 3 + betLineWinData.betLine[i], 0); // overridden to change reel id and symbol id as per 15 reels.

            if(!symbol) {
                debugger;
                throw new Error(`Error: SequentiallyBetLineInitialWPController.playBetWinPresentation(): Cannot find symbol at reel ${i} symbol ${betLineWinData.betLine[i]}`);
            }

            symbolDelay += this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, symbolDelay, symbol!, i, betLineWinData.betLine[i]);

            if(this._winSymbols.indexOf(symbol) === -1) {
                this._winSymbols.push(symbol);
            }
        }
        if(this._betLineWinConfig.shouldPlayBetLine) {
            timeline.add(() => {
                if(this._gameData!.isBigWin) {
                    SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.BET_LINE_BIG_WIN);
                } else {
                    // #403
                    if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.BET_LINE);
                    }
                }

                this.playBetLine(betLineWinData.betLineIndex + 1);
            }, 0);
        }

        return this.getNextBetWinAnimationTimeOffset();
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):number {
        let symName:string = symbol.symName;

        const symbolAnimation:Timeline = symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : 0
        })!;

        timeline.add([
            () => this.sortSymbolDepthToTop(symbol),
            symbolAnimation,
            () => this._isShowingYellow = true,
            () => this._gameView.playFireOnWinningSymbols(reelId * 3 + symbolId)
        ], startTime);

        if(symName.indexOf("L") !== -1) {
            let item:PIXI.Sprite;

            item = this._animItems[reelId * 3 + symbolId];

            const duration:number = 0.3;

            item.visible = true;

            item.texture = GameResources.getTextures(`${symName}/${symName}-H`)[0];
            item.alpha = 0;

            timeline.add(TweenLite.to(item, duration, {alpha : 1}), startTime);
            timeline.add(TweenLite.to(item, duration, {alpha : 0}), startTime + duration);
        }

        return this.getNextSymbolAnimationTimeOffset();
    }

    protected addFeatureEventHandlers():void {
        super.addFeatureEventHandlers && super.addFeatureEventHandlers();

        EventHandler.addEventListener(this, "FORCE_HIDE_TOTAL_WIN", () => this._gameView.hideTotalReSpinText());
        EventHandler.addEventListener(this, "SHOW_TOTAL_WIN", () => this._gameView.showTotalReSpinText());
        EventHandler.addEventListener(this, TombOfNefertitiMultiplierEvents.MULTIPLIER_SHOWN, () => this._isMultiplierShown = true);
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, TombOfNefertitiInitCurseRespinController.HIGHLIGHT_FIRST_CURSE_REEL, () => this._gameView.playFireOnWinningSymbols(3));

        EventHandler.addEventListener(this, "FinishWinPres", () => {
            if(this._isFinishPending) {
                this._isFinishPending = false;
                if((this._nextGameMode != GameMode.NORMAL) && !(this._gameData!.singleWin)) {
                    TweenLite.delayedCall(1.2, () => EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN")));
                }
                let currentModeFreeSpin:boolean = (this._currentGameMode.indexOf(GameMode.FREESPIN) !== -1),
                    isAutoplayActive = GameSetting.isAutoplayRound,
                    delayTime = 0;

                if(currentModeFreeSpin || (!currentModeFreeSpin && (isAutoplayActive || (this._nextGameMode === GameMode.FREESPIN)))) {
                    delayTime = 1;
                }
                this._finishMethodTween = TweenLite.delayedCall(delayTime, () => {
                    this.finish();
                });
            }
        });
    }

    protected finish(isAborted?:boolean):void {
        if(this._isFinishedCalled) {
            return;
        }

        // added this after FW upgrade to 0.47.x series, earlier aborting initial WP aborts all but now it goes to next presentation which can be big win some times
        // therefore stopping the yellow fire while exiting from this WP in case of big win irrespective of abort.
        // but we do need the yellow fire in case next WP is TombOfNefertitiInitCurseRespinController
        if(this._isShowingYellow && this._gameData!.isBigWin) {
            this._gameView.stopAll();
        }

        this._isFinishedCalled = true;
        if((this._nextGameMode.indexOf("RESPIN") !== -1) && !this._gameData!.isBigWin) {
            //UPDATE_WIN_TO_BOTTOM
            if(this._currentGameMode.indexOf("FREESPIN") === -1) {
                this._winCountUp.updateRoundWinAmount();
            }
        }
        super.finish(isAborted);
    }

    protected startWinPresentation():void {
        this._isFinishedCalled = false;
        if(!this._gameData!.singleWin) {
            if(this._currentGameMode.indexOf('RESPIN') !== -1) {
                // Do Merging for Previous round
                this._winCountUp.showTotalWin(this._reSpinWinAmount);
                this._isFinishPending = true;
            } else {
                this.finish(false);
            }
        } else {
            super.startWinPresentation();
            if(this._winType) {
                SlotGame.sound.fadeAmbience(0.2, 500);
                // #403
                if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                    SlotGame.sound.playEffect("win-tiny");
                }
            }
        }
    }

    private onBeforeSpinStart():void {
        if(this._isShowingYellow) {
            this._gameView.stopAll();
            this._isShowingYellow = false;
        }

        if(this._nextGameMode.indexOf("RESPIN") === -1) {
            TweenLite.to(() => {}, TombOfNefertitiGameConfig.instance.SPIN_DELAY, {
                onComplete : () => {
                    EventHandler.dispatchEvent(new GameEvent("FORCE_HIDE_TOTAL_WIN"));
                }
            });
        }
    }

    private setCountUpSound():number {
        let count:number = 0,
            startTime:number = 0.5;

        switch(this._winType!) {
            case "win-tiny":
                count = 1;
                startTime = 0.5;
                break;
            case "win-small":
                count = 2;
                startTime = 0.6;
                break;
            case "win-medium":
                count = 3;
                startTime = 0.8;
                break;
            case "win-large":
                count = 5;
                startTime = 0.9;
                break;
        }

        this._countUpSound = "countup-" + count + "Bling";

        return startTime;
    }

    // #417
    private showBetlineAmountInitialWin(betWins: IBetWinData[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            container: PIXI.Container = new PIXI.Container();

        if (TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
            return tl;
        }

        container.position.set(640, 360);
        container.alpha = 0;

        betWins.forEach((betWin: IBetWinData, idx: number) => {
            const winAmount: PIXI.Text = new PIXI.Text(betWin.multipliedAmount.toFixed(2), new PIXI.TextStyle({
                fontFamily: OpenSans.FAMILY,
                fontSize: 36,
                fontWeight: FontWeight.BOLD,
                fill: "#fff"
            }));
            let effectiveIdx: number = idx;

            if (betWins.length > 20 && (idx >= (betWins.length / 2))) {
                effectiveIdx = (idx - (betWins.length / 2));
                winAmount.x = (container.children[0] as PIXI.Text).width + 30; // #325
            }

            winAmount.y = (effectiveIdx * 40);

            if (betWins.length > 20) {
                winAmount.anchor.set(0.5, 0);
            }

            container.addChild(winAmount);
        });

        if (betWins.length > 13) {
            container.scale.set(0.65);
            container.y -= 90;
        }
        container.pivot.set(container.width / 2, container.height / 2);

        StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).addChild(container);

        tl.to(container, 0.1, {
            alpha: 1
        });
        tl.to(container, 0.5, {
            y: "-=50"
        });
        tl.to(container, 0.1, {
            alpha: 0
        });
        tl.add(() => {
            container.removeChildren();
            StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.INITIAL_WIN_AMOUNT_BET_LINES.name).removeChild(container);
        });

        return tl;
    }
}